import React from "react";
import { motion } from "framer-motion";
export const Backdrop = () => {
    return (React.createElement(motion.div, { className: "modal-backdrop", initial: { opacity: 0 }, animate: { opacity: 0.5 }, exit: { opacity: 0 } }));
};
